import { createWebHistory, createRouter } from "vue-router";

import IndexView from "@/pages/index/index.vue";
import cardapioRestaurante from "@/pages/index/cardapio-restaurante.vue";
import cardapioGelateria from "@/pages/index/cardapio-gelateria.vue";
import cardapioPastelaria from "@/pages/index/cardapio-pastelaria.vue";
import cardapioArmazem from "@/pages/index/cardapio-armazem.vue";
import mapaInterativo from "@/pages/index/mapa-interativo.vue";
import acompanhamentoSenhas from "@/pages/index/acompanhamento-senhas.vue";
import acompanhamentoCozinha from "@/pages/index/acompanhamento-cozinha.vue";
import recuperarSenha from "@/pages/recuperar-senha.vue";
import politicaDePrivacidade from "@/pages/politica-de-privacidade.vue";

const routes = [
  {
    path: "/",
    name: "index",
    component: IndexView,
  },
  {
    path: "/recuperar-senha",
    name: "recuperar-senha",
    component: recuperarSenha,
  },
  {
    path: "/politica-de-privacidade",
    name: "politica-de-privacidade",
    alias: ["/privacidade", "/privacy"],
    component: politicaDePrivacidade,
  },
  {
    path: "/restaurante",
    name: "restaurante",
    component: cardapioRestaurante,
  },
  {
    path: "/gelateria",
    name: "gelateria",
    component: cardapioGelateria,
  },
  {
    path: "/pastelaria",
    name: "pastelaria",
    component: cardapioPastelaria,
  },
  {
    path: "/armazem",
    name: "armazem",
    component: cardapioArmazem,
  },
  {
    path: "/mapa",
    name: "mapa-interativo",
    component: mapaInterativo,
  },
  {
    path: "/acompanhamento-senhas/:lojaId",
    name: "acompanhamento-senhas",
    component: acompanhamentoSenhas,
  },
  {
    path: "/acompanhamento-cozinha/:lojaId",
    name: "acompanhamento-cozinha",
    component: acompanhamentoCozinha,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: "index" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;